import axios from "axios";
import {
  getApiPaginationProd,
  getApiProd,
  postApiProd,
} from "services/mainService";

//-------------------Message--------------------
export const getListConversationModel = async (userJid) => {
  try {
    const response = await getApiProd(`message/v2/list`, null, {
      user_jid: userJid,
    });

    if (response.success)
      return {
        success: true,
        data: response.data?.map((item) => ({
          id: item.id,
          partnerJid: item.partnerJid,
          lastMessage: item.lastMessage,
          unreadCount: item.unreadCount,
        })),

        message: response.message,
      };
    else
      return {
        success: false,
        message: response.message,
      };
  } catch (err) {
    return {
      success: false,
      message: err.message || "get project failed",
    };
  }
};
export const getConversationModel = async (userAJid, userBJid, page, limit) => {
  try {
    const response = await getApiPaginationProd(`message/v2/item`, null, {
      user_a_jid: userAJid,
      user_b_jid: userBJid,
      page,
      limit,
    });
    if (response.success)
      return {
        success: true,
        data: response.data,
        total: response.total,
        totalPage: response.totalPage,
        message: response.message,
      };
    else
      return {
        success: false,
        message: response.message,
      };
  } catch (err) {
    return {
      success: false,
      message: err.message || "get project failed",
    };
  }
};

export const getListUnreadMessageModel = async (userJid) => {
  try {
    const response = await getApiProd(`message/V2/unread/count`, null, {
      user_jid: userJid,
    });
    if (response.success)
      return {
        success: true,
        data: response.data,
        message: response.message,
      };
    else
      return {
        success: false,
        message: response.message,
      };
  } catch (err) {
    return {
      success: false,
      message: err.message || "get count inbox message failed",
    };
  }
};
export const sendMesageModel = async (senderJid, receipentJid, message) => {
  try {
    const response = await postApiProd(`message/v2/create`, null, null, {
      sender_jid: senderJid,
      receipent_jid: receipentJid,
      message,
    });
    if (response.success)
      return {
        success: true,
        data: response.data,
        message: response.message,
      };
    else
      return {
        success: false,
        message: response.message,
      };
  } catch (err) {
    return {
      success: false,
      message: err.message || "send message failed",
    };
  }
};

export const markAsReadConversationModel = async (senderJid, receipentJid) => {
  try {
    const response = await postApiProd(`message/v2/mark-as-read`, null, null, {
      sender_jid: senderJid,
      receipent_jid: receipentJid,
    });
    if (response.success)
      return {
        success: true,
        data: response.data,
        message: response.message,
      };
    else
      return {
        success: false,
        message: response.message,
      };
  } catch (err) {
    return {
      success: false,
      message: err.message || "mark message as read failed",
    };
  }
};

//----------------CONTACTS-----------------

export const checkUserExistEjabberModel = async (ownerJid) => {
  try {
    const response = await axios.post(
      `https://chat.cuaps.id/api/check_account`,
      {
        user: ownerJid,
        host: "chat.cuaps.id",
      },
      {
        headers: {
          Authorization: `Basic ${btoa("admins@chat.cuaps.id:12345678")}`,
        },
      }
    );
    if (response)
      return {
        success: true,
        data: response.data,
        message: response.message,
      };
    else
      return {
        success: false,
        message: response.message,
      };
  } catch (err) {
    return {
      success: false,
      message: err.message || "create contact failed",
    };
  }
};
export const createContactModel = async (
  ownerJid,
  username,
  phonenumber,
  exist
) => {
  try {
    const response = await postApiProd(`message/contact/create`, null, null, {
      owner_jid: ownerJid,
      username,
      phonenumber,
      exist,
    });
    if (response.success)
      return {
        success: true,
        data: response.data,
        message: response.message,
      };
    else
      return {
        success: false,
        message: response.message,
      };
  } catch (err) {
    return {
      success: false,
      message: err.message || "create contact failed",
    };
  }
};

export const deleteContactModel = async (id) => {
  try {
    const response = await postApiProd(`message/contact/delete`, null, null, {
      id,
    });
    if (response.success)
      return {
        success: true,
        data: response.data,
        message: response.message,
      };
    else
      return {
        success: false,
        message: response.message,
      };
  } catch (err) {
    return {
      success: false,
      message: err.message || "create contact failed",
    };
  }
};

export const updateContactModel = async (id, username, phonenumber, exist) => {
  try {
    const response = await postApiProd(`message/contact/update`, null, null, {
      id: id,
      username,
      phonenumber,
      exist,
    });
    if (response.success)
      return {
        success: true,
        data: response.data,
        message: response.message,
      };
    else
      return {
        success: false,
        message: response.message,
      };
  } catch (err) {
    return {
      success: false,
      message: err.message || "create contact failed",
    };
  }
};
export const getContactsModel = async (jid) => {
  try {
    const response = await getApiProd("message/contact/list", null, {
      owner_jid: jid,
    });
    if (response.success)
      return {
        success: true,
        data: response.data,
        message: response.message,
      };
    else
      return {
        success: false,
        message: response.message,
      };
  } catch (error) {
    return {
      success: false,
      message: error.message,
    };
  }
};
